<template>
  <div id="fm_display_sidebar">
    <!--<el-row>
      <el-col :span="24">
        <h3>Customer Feedback & Story Research Tool</h3>
        <p>Use the filter box below to search for other uses cases that might be similar to yours. That will show stories and feedback that existing customer have shared.</p>
      </el-col>
    </el-row>-->
    <hr>
    <!--
    <el-row :gutter="20" type="flex">
      <el-col :span="8">
        <fm_container_sidebar></fm_container_sidebar>
      </el-col>
      <el-col :span="16">
        <fm_container_results :show_results_per_page_selector="show_results_per_page_selector"></fm_container_results>
      </el-col>
    </el-row>
    -->

    <!-- own approach - no mobile tune yet
    <div id="fm_left_sidebar_container">
      <fm_container_sidebar></fm_container_sidebar>
    </div>
    <div id="fm_right_content_container">
      <fm_container_results :show_results_per_page_selector="show_results_per_page_selector"></fm_container_results>
    </div>
    <div style="clear: both"></div>
    -->

    <!-- vue-flex approach - did not get it working-
    <div>
      <flex-row>
        <flex-col

        >
          <fm_container_sidebar></fm_container_sidebar>
        </flex-col>
        <flex-col
        >
          <fm_container_results :show_results_per_page_selector="show_results_per_page_selector"></fm_container_results>
        </flex-col>
      </flex-row>
    </div>
    -->
      <grid wrap="wrap" :rwd="{compact: 'stack'}">
        <grid-item size="1/3" :rwd="{compact: '1/1'}" style="margin-bottom: 20px;">
          <fm_container_sidebar></fm_container_sidebar>
        </grid-item>
        <grid-item size="2/3" :rwd="{compact: '1/1'}">

          <fm_container_results :show_results_per_page_selector="show_results_per_page_selector" :resultColumns="resultColumns"></fm_container_results>
        </grid-item>
      </grid>

  </div>
</template>

<script>
  import SidebarContainer from './ContainerSidebar.vue';
  import ResultContainer from './ContainerResults.vue';
  //import GridItem from "vue-fraction-grid/components/GridItem";
  //import Grid from "vue-fraction-grid/components/GridItem";

  //import FlexRow from "vue-flex/lib/components/FlexRow";
  //import FlexCol from "vue-flex/lib/components/FlexCol";

  export default {
    props: ['show_results_per_page_selector', 'resultColumns'],
    components: {
      //FlexCol,
      //FlexRow,
      //GridItem,
      //Grid,
      'fm_container_sidebar': SidebarContainer,
      'fm_container_results': ResultContainer
    },
    data(){
      return {

      }
    },
    methods: {

    },
    computed: {

    },
    created(){

    }
  }
</script>

<style scoped lang="scss">
#fm_display_sidebar {
  max-width: 1200px;
}

div#fm_left_sidebar_container {
  float: left;
  width: 32%;
  min-width: 300px;
  margin-right: 10px;
}

div#fm_right_content_container {
  float: left;
  width: 65%;
  margin-left: 10px;
}

</style>